module.exports = __webpack_public_path__ + "static/media/FocusArea.1fbebbda.svg";